// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Sortable from '@stimulus-components/sortable';
import AutoSubmit from '@stimulus-components/auto-submit';
import PrelineController from "./preline_controller";
import FlashMessageController from "./flash_message_controller";
import ContentLoader from './content_loader_controller';
import AvatarController from './avatar_controller';
import ResetFormController from './reset_form_controller';
import ThemeController from './theme_controller';
import MileStoneSelectController from "./milestone_select_controller";
import TargetUnitController from "./target_unit_controller";
import InlineEditController from './inline_edit_controller';
import ToggleController from './toggle_controller';
import ReviewTextFieldController from './review_text_field_controller';
import FilterTextFieldController from './filter_text_field_controller';
import HabitRepeatController from './habit_repeat_controller';

application.register("sortable", Sortable);
application.register('auto-submit', AutoSubmit)
application.register("preline", PrelineController);
application.register("flash_message", FlashMessageController);
application.register("content-loader", ContentLoader);
application.register("avatar", AvatarController);
application.register("reset-form", ResetFormController);
application.register("theme", ThemeController);
application.register("milestone-select", MileStoneSelectController);
application.register("target-unit", TargetUnitController);
application.register("inline-edit", InlineEditController);
application.register("toggle", ToggleController);
application.register("review-text-field", ReviewTextFieldController);
application.register("filter-text-field", FilterTextFieldController);
application.register("habit-repeat", HabitRepeatController);

